import { publishServices } from '../services/publishService';
import { publishConstant, notificationConstant } from '../constants';
import { downloadCSV } from '../lib/downloadToCsv';

function searchQuestions(param) {
    return dispatch => {
        dispatch({ type: notificationConstant.SHOW_LOADER, payload: {} })
        publishServices.searchQuestions(param)
            .then(data => {
                dispatch({ type: publishConstant.SELECTED_FILTERS, payload: param })
                dispatch({ type: notificationConstant.HIDE_LOADER, payload: {} })
                dispatch({ type: publishConstant.SEARCH_QUESTION_SUCCESS, payload: data })

            })
    }
}

function getFilters() {
    return dispatch => {
        publishServices.getFilters()
            .then(data => {
                dispatch({ type: publishConstant.FILTERS, payload: data })
            })
    }
}

function publishQuestions(questions, selFilters) {
    return dispatch => {
        dispatch({ type: notificationConstant.SHOW_LOADER, payload: {} })
        publishServices.publishQuestions(questions)
            .then(data => {
                publishServices.searchQuestions(selFilters)
                    .then(searchData => {
                        dispatch({ type: publishConstant.SELECTED_FILTERS, payload: selFilters })
                        dispatch({ type: notificationConstant.HIDE_LOADER, payload: {} })
                        dispatch({ type: publishConstant.SEARCH_QUESTION_SUCCESS, payload: searchData })

                    })
            })
    }
}

function updateQuestion(question, selFilters) {
    return dispatch => {
        dispatch({ type: notificationConstant.SHOW_LOADER, payload: {} })
        publishServices.updateQuestion(question).then(data => {
            publishServices.searchQuestions(selFilters)
                .then(searchData => {
                    dispatch({ type: publishConstant.SELECTED_FILTERS, payload: selFilters })
                    dispatch({ type: notificationConstant.HIDE_LOADER, payload: {} })
                    dispatch({ type: publishConstant.SEARCH_QUESTION_SUCCESS, payload: searchData })

                })
        });
    }
}

function bulkPublish(data) {
    return dispatch => {
        dispatch({ type: notificationConstant.SHOW_LOADER, payload: {} })
        publishServices.bulkPublish(data)
            .then(res => {
                dispatch({ type: notificationConstant.HIDE_LOADER, payload: {} })
                alert(res.statusMessage);
                console.log(res);
            })
    }
}
function downloadSerchResultCSV(params) {
    return dispatch => {
        dispatch({ type: notificationConstant.SHOW_LOADER, payload: {} })
        publishServices.downloadSerchResultCSV(params)
            .then(res => {
                downloadCSV(res.questions)
                dispatch({ type: notificationConstant.HIDE_LOADER, payload: {} })
            })
    }
}
function fetchSolutionText(solution, callback) {
    return dispatch => {
        publishServices.fetchSolutionText(solution, callback)
            .then(data => {
                dispatch({ type: publishConstant.FETCH_SOLUTION_TEXT, payload: data });
            })
    }
}

export const publishActions = {
    searchQuestions,
    getFilters,
    publishQuestions,
    updateQuestion,
    bulkPublish,
    downloadSerchResultCSV,
    fetchSolutionText
};